// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Mail: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m2.625 5.219 8.75 7a.999.999 0 0 0 1.252-.002l-.002.001 8.75-7a.994.994 0 0 1 .36-.181l.007-.002A1.994 1.994 0 0 0 20 3.999H4a1.99 1.99 0 0 0-1.737 1.026l-.005.01c.141.038.264.101.369.185l-.002-.002v.001Z" />
    <path d="M13.874 13.781a2.97 2.97 0 0 1-1.875.662c-.713 0-1.367-.25-1.88-.666l.006.004L2 7.28V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7.28l-8.126 6.501Z" />
  </SvgIcon>
);

Mail.activeColor = 'inherit';
Mail.muiName = 'Mail';
